import React from 'react';

import { Heading, ListingCard } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionRecentlyViewedListings = props => {
  const {
    recentlyViewedListings,
    fetchRecentlyViewedListingsInProgress,
    fetchRecentlyViewedListingsError,
  } = props;

  if (
    fetchRecentlyViewedListingsInProgress ||
    fetchRecentlyViewedListingsError ||
    recentlyViewedListings.length === 0
  ) {
    return null;
  }

  return (
    <div className={css.sectionRecentlyViewedListings}>
      <Heading as="h2" rootClassName={css.sectionTitle}>
        <FormattedMessage id="ListingPage.recentlyViewedListings" />
      </Heading>
      <div className={css.recentlyViewedListings}>
        {recentlyViewedListings.map(l => {
          return <ListingCard key={l.id.uuid} listing={l} />;
        })}
      </div>
    </div>
  );
};

export default SectionRecentlyViewedListings;
